import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@telus-uds/components-web';

import { addLocale, replace } from '../misc';
import { Image } from '../design/elements';
import { formCategoryStyle } from './style';
import { useTranslationsContext } from '../context/TranslationsContext';
import request, { adtApiHost, sof1ApiHost } from '../utils/request';
import { adtHomeUrl, sof1HomeUrl } from '../utils/constant';

const FormCategory = ({
  category = null,
  row,
  locale,
  history,
  isFreezed = false
}) => {
  const {
    name,
    title,
    image,
    description,
    info,
    importantInfo,
    forms,
    platform
  } = category;
  const style = formCategoryStyle(row);
  const addLocaleToUrl = addLocale(locale);
  const translations = useTranslationsContext();

  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const { role: { name: roleName = '' } = {} } = userProfile || {};

  const {
    WLS: {
      REPORTING: { reportingHomeButtonTitle, manageDevicesCreditsFee }
    }
  } = translations;

  useEffect(() => {
    if (
      document.getElementById('footer') &&
      document.getElementById('footer').style
    )
      document.getElementById('footer').style.display = 'block';

    if (roleName !== 'ADMIN' && document.getElementById('2')) {
      document.getElementById('2').style.display = 'none';
    }

    if (roleName !== 'ADMIN' && document.getElementById('3')) {
      document.getElementById('3').style.display = 'none';
    }
  }, [roleName]);

  return (
    <div style={style}>
      <div
        className="hidden-xs hidden-sm"
        style={{
          display: 'inline-block',
          margin: '10px 20px 20px 20px',
          verticalAlign: 'top',
          minWidth: '175px'
        }}
      >
        <Image image={image} />
      </div>
      <div style={{ flex: 1 }}>
        <div>
          <Typography heading="h3" variant={{ size: 'h3' }} block>{title}</Typography>
        </div>
        <div style={{ color: '#999999' }}>
          <>
            {description && (
              <Typography>
                {description}
              </Typography>
            )}
            {info && (
              <>
                <br />
                <Typography>{info}</Typography>
              </>
            )}
            {importantInfo && (
              <>
                <br />
                <Typography variant={{ colour: 'error' }}><b>{importantInfo}</b></Typography>
              </>
            )}
          </>
        </div>

        {forms && (
          <div style={{ paddingTop: '20px' }}>
            {forms.map((form, index) => {
              const key = `form${index}`;
              const url = addLocaleToUrl(
                `/${replace(name)}/${replace(form.fields.name)}`
              );

              return (
                !form.fields.hideOnDashboard && (
                  <Fragment key={key}>
                    <span>
                      <Button
                        type="button"
                        disabled={isFreezed}
                        id={index}
                        onClick={() => {
                          if (platform === 'SOF1') {
                            window.location.replace(
                              request.getSSOLoginState()
                                ? `${sof1ApiHost}/users/sso-login?url=${JSON.stringify(
                                    {
                                      title,
                                      name,
                                      formField: form.fields
                                    }
                                  )}`
                                : sof1HomeUrl
                            );
                          } else if (platform === 'ADT') {
                            window.location.replace(
                              request.getSSOLoginState()
                                ? `${adtApiHost}/users/sso-login`
                                : adtHomeUrl
                            );
                          } else if (
                            form.fields.title === manageDevicesCreditsFee
                          ) {
                            history.push('/upload-hardware-grid');
                          } else history.push(url);
                        }}
                        variant={{ priority: 'high' }}
                      >
                        {form.fields.title}
                      </Button>
                    </span>
                    &nbsp;
                  </Fragment>
                )
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

FormCategory.propTypes = {
  category: PropTypes.shape({
    title: PropTypes.string,
    name: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    image: PropTypes.objectOf(PropTypes.object),
    description: PropTypes.string,
    info: PropTypes.string,
    importantInfo: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    forms: PropTypes.arrayOf(PropTypes.object),
    platform: PropTypes.string
  }),
  row: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    go: PropTypes.func
  }).isRequired,
  isFreezed: PropTypes.bool
};

export default FormCategory;
